import { FiCpu, FiShield, FiZap, FiActivity, FiSearch, FiCode } from "react-icons/fi";
import { BsRobot, BsUnity, BsVectorPen, BsDatabaseLock, BsCloudCheck } from "react-icons/bs";
import { LuBrain, LuBug, LuBuilding2, LuClipboardList, LuClock, LuCode, LuCpu, LuLayoutDashboard, LuRocket, LuShield, LuShoppingBag, LuUsers } from "react-icons/lu";

export const trendingTechHeroData = {
  backgroundImage: "/images/serviceBanners/AIImage.webp",
  whiteImage: "/images/serviceBanners/TrandingW.webp",
  subTitle: "We Create Future-Ready Technology Solutions",
  title: (
    <>
      Modern <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-600">Trending Technologies </span> Solutions
    </>
  ),
  description:
    "We deliver advanced, scalable, and future ready technology solutions using trending innovations to help businesses improve efficiency, accelerate digital transformation, and achieve sustainable growth in a highly competitive digital environment.",
  primaryButton: {
    title: "Get Started",
    onClick: () => console.log("Get Started clicked"),
  },
  secondaryButton: {
    title: "View Our Work",
    onClick: () => console.log("View Our Work clicked"),
  },
  featureData: [
    {
      icon: "/images/services/website/high_performance.webp",
      title: "AI & Automation Solutions",
      desc: "Smart technologies built for modern business growth.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/responsive.webp",
      title: "Cloud & Scalable Systems",
      desc: "Flexible and scalable infrastructure for future-ready platforms.",
      iconColor: "#22d3ee",
    },
    {
      icon: "/images/services/website/secure.webp",
      title: "Secure Modern Technologies",
      desc: "Advanced security with reliable technology architecture.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/clean_code.webp",
      title: "Next-Gen Development Stack",
      desc: "Modern, optimized, and scalable development solutions.",
      iconColor: "#34d399",
    },
  ],
  floatingIcons: [
    {
      image: "/images/services/website/nodejs.webp",
      top: "16%",
      right: "6%",
      containerSize: 80,
      iconSize: 60,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
    {
      image: "/images/services/website/reactjs.svg",
      top: "8%",
      right: "14%",
      containerSize: 70,
      iconSize: 50,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
    {
      image: "/images/services/website/python.svg",
      top: "20%",
      right: "20%",
      containerSize: 60,
      iconSize: 40,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
  ],
};

export const trendingTechBenefits = [
  {
    icon: <FiCpu className="w-8 h-8" />,
    title: "AI-Driven Automation",
    desc: "Reduce operational costs and eliminate manual errors with intelligent, self-learning systems.",
  },
  {
    icon: <FiShield className="w-8 h-8" />,
    title: "Immutable Security",
    desc: "Leverage Blockchain for decentralized data integrity and transparent transaction tracking.",
  },
  {
    icon: <FiZap className="w-8 h-8" />,
    title: "Immersive Engagement",
    desc: "Boost customer retention with high-fidelity AR/VR experiences that bridge the physical and digital.",
  },
  {
    icon: <FiActivity className="w-8 h-8" />,
    title: "Predictive Analytics",
    desc: "Harness the power of data to forecast market trends and user behavior with high precision.",
  },
];

export const trendingTechServices = [
  {
    icon: <BsRobot size={36} color="#f59e0b" />,
    title: "AI & Machine Learning Solutions",
    description: "Custom AI and machine learning solutions for automation and intelligent decision-making.",
    image: "/images/AI_ML_Services/AIMLBanner.webp",
    link: "/ai-ml-development-services-india",
    points: ["Custom AI Solutions", "High Performance Systems", "Ongoing Support"],
  },
  {
    icon: <BsDatabaseLock size={36} color="#10b981" />,
    title: "Blockchain Development Solutions",
    description: "Secure blockchain applications and smart contract development services.",
    image: "/images/blockChain/blockChainBanner.webp",
    link: "/blockchain-development-services-india",
    points: ["Custom Blockchain Solutions", "Scalable Architecture", "Ongoing Support"],
  },
  {
    icon: <BsVectorPen size={36} color="#8b5cf6" />,
    title: "AR App Development Solutions",
    description: "Interactive augmented reality applications for modern digital experiences.",
    image: "/images/TrendingTechnologies/ARAppdevelopment.webp",
    link: "/ar-app-development-services-india",
    points: ["Custom AR Solutions", "High Performance Apps", "Ongoing Support"],
  },
  {
    icon: <BsUnity size={36} color="#ec4899" />,
    title: "VR App Development Solutions",
    description: "Immersive virtual reality applications for training and interactive experiences.",
    image: "/images/TrendingTechnologies/VRAppdevelopment.webp",
    link: "/vr-app-development-services-india",
    points: ["Custom VR Solutions", "Optimized Performance", "Ongoing Support"],
  },
  {
    icon: <BsCloudCheck size={36} color="#3b82f6" />,
    title: "Cloud & DevOps Solutions",
    description: "Scalable cloud infrastructure and DevOps automation for modern businesses.",
    image: "/images/Devops_cloud/CloudTechnology.webp",
    link: "/devops-cloud-development-services-india",
    points: ["Cloud Infrastructure Setup", "Secure DevOps Pipeline", "Ongoing Support"],
  },
];

export const trendingTechProcess = [
  {
    step: "01",
    title: "Feasibility Study",
    description: "We analyze your tech ecosystem to identify high-impact areas for AI or Immersive integration.",
    points: ["Gap analysis", "Tech stack selection", "ROI mapping"],
  },
  {
    step: "02",
    title: "MVP Prototyping",
    description: "Developing a 'Minimum Viable Product' to test core concepts and gather early user data.",
    points: ["Rapid prototyping", "Algorithm testing", "User flow design"],
  },
  {
    step: "03",
    title: "Core Engineering",
    description: "Building scalable infrastructure, training models, or developing 3D environments.",
    points: ["Model training", "3D asset creation", "Secure integration"],
  },
  {
    step: "04",
    title: "Optimization & QA",
    description: "Extensive testing for latency, security vulnerabilities, and platform compatibility.",
    points: ["Performance tuning", "Security audit", "UI/UX validation"],
  },
  {
    step: "05",
    title: "Deployment & Scaling",
    description: "Launching the solution and setting up 24/7 monitoring for continuous improvement.",
    points: ["Cloud deployment", "Continuous learning", "Future scaling"],
  },
];

export const trendingTechFaqs = [
  //   {
  //     q: "How can AI help my small business?",
  //     a: "AI can automate customer support via chatbots, personalize marketing, and optimize inventory management without manual intervention.",
  //   },
  {
    q: "What is the difference between AR and VR for business?",
    a: "AR overlays digital info on the real world (ideal for retail/navigation), while VR creates a fully simulated environment (ideal for training/gaming).",
  },
  //   {
  //     q: "Is Blockchain only for cryptocurrency?",
  //     a: "No. It is widely used for supply chain tracking, secure medical records, and transparent voting systems.",
  //   },
  {
    q: "Do you provide cross-platform AR/VR support?",
    a: "Yes, we develop for iOS (ARKit), Android (ARCore), and VR headsets like Meta Quest and HTC Vive.",
  },
];
export const trendingTechStack = ["AI", "MachineLearning", "Blockchain", "ARVR", "IoT", "CyberSecurity", "CloudComputing", "DataScience"];
export const trendingTechIcons = {
  AI: "/images/icons/ai.webp",
  MachineLearning: "/images/icons/machinelearning.webp",
  Blockchain: "/images/icons/blockchain.webp",
  ARVR: "/images/icons/arvr.webp",
  IoT: "/images/icons/iot.webp",
  CyberSecurity: "/images/icons/cybersecurity.webp",
  CloudComputing: "/images/icons/cloudcomputing.webp",
  DataScience: "/images/icons/datascience.webp",
};

export const emergingTechAboutData = [
  {
    title: "Future-Driven Technology Solutions for Modern Businesses",
    content: (
      <>
        Businesses today are rapidly adopting advanced digital innovations to improve operational efficiency, customer experiences, and long-term scalability. Professional{" "}
        <b className="text-text-primary font-semibold">emerging technology solutions</b> help organizations modernize their digital infrastructure and adapt to changing market
        demands. A trusted provider of <b className="text-text-primary font-semibold">latest technology services</b> focuses on building intelligent ecosystems that support
        automation, innovation, and sustainable digital growth across industries.
      </>
    ),
  },

  {
    title: "Intelligent Technologies for Digital Transformation",
    content: (
      <>
        Modern enterprises require adaptive technologies that improve decision-making and streamline complex business processes. Companies investing in{" "}
        <b className="text-text-primary font-semibold">AI and blockchain development</b> benefit from advanced digital frameworks that support transparency, automation, and secure
        data management. Businesses also collaborate with providers offering{" "}
        <a href="https://tychotechnologies.com/ai-ml-development-services-india/" className="text-cyan-400 underline hover:text-cyan-300">
          ai ml development services
        </a>{" "}
        to create intelligent systems capable of predictive analysis, workflow optimization, and personalized digital experiences for evolving customer expectations.
      </>
    ),
  },

  {
    title: "Scalable Innovation with Advanced Development Expertise",
    content: (
      <>
        Organizations across healthcare, fintech, logistics, retail, and enterprise sectors continue adopting modern technologies to remain competitive in fast-changing digital
        environments. Businesses seeking scalable innovation often work with experts providing{" "}
        <a href="https://tychotechnologies.com/blockchain-development-services-india" className="text-cyan-400 underline hover:text-cyan-300">
          blockchain development services
        </a>{" "}
        to create decentralized platforms, secure transaction systems, and reliable digital infrastructures. Professional{" "}
        <b className="text-text-primary font-semibold">innovative digital transformation services</b> also help businesses improve operational adaptability while preparing their
        digital ecosystems for future expansion.
      </>
    ),
  },

  {
    title: "Reliable Future Technology Services in India",
    content: (
      <>
        The demand for advanced digital innovation continues to rise among businesses seeking long-term technological growth and modernization. Companies searching for scalable
        digital expertise frequently choose a trusted <b className="text-text-primary font-semibold">technology consulting company in india</b> for strategic planning, technical
        consultation, and future-focused implementation support. Businesses also rely on professional <b className="text-text-primary font-semibold">future tech solutions india</b>{" "}
        providers to strengthen digital capabilities, improve business agility, and accelerate sustainable transformation in competitive global markets.
      </>
    ),
  },
];

export const trendingPortfolioData = {
  subtitle: "OUR WORK",
  title: "Trending Apps We're Proud Of",
  buttonText: "View All Projects",
  buttonLink: "#all-projects",
  apps: [
    {
      title: "Foodie Express",
      badge: "Food Delivery App",
      badgeColor: "bg-[#00d2ff]/10 text-[#00d2ff] border-[#00d2ff]/20",
      desc: "A fast and intuitive food delivery app with real-time tracking, secure payments & smooth experience.",
      downloads: "100K+",
      rating: "4.8",
      image: "/images/MobileAppDevelopment/foodie_express.png",
    },
    {
      title: "FinMate",
      badge: "FinTech App",
      badgeColor: "bg-[#a855f7]/10 text-[#a855f7] border-[#a855f7]/20",
      desc: "A personal finance app to manage expenses, budgets & investments with advanced analytics.",
      downloads: "250K+",
      rating: "4.9",
      image: "/images/MobileAppDevelopment/finmate.png",
    },
    {
      title: "TravelGo",
      badge: "Travel App",
      badgeColor: "bg-[#3b82f6]/10 text-[#3b82f6] border-[#3b82f6]/20",
      desc: "A travel booking app for flights, hotels & packages with best deals and easy bookings.",
      downloads: "500K+",
      rating: "4.7",
      image: "/images/MobileAppDevelopment/travelgo.png",
    },
    {
      title: "TravelGo",
      badge: "Travel App",
      badgeColor: "bg-[#3b82f6]/10 text-[#3b82f6] border-[#3b82f6]/20",
      desc: "A travel booking app for flights, hotels & packages with best deals and easy bookings.",
      downloads: "500K+",
      rating: "4.7",
      image: "/images/MobileAppDevelopment/travelgo.png",
    },
  ],
};
export const trendingSolutionsAndProcessData = {
  buildSubtitle: "WHAT WE BUILD",
  buildTitle: "Trending Technology Solutions for Every Business Need",
  buildCards: [
    {
      title: "AI & Automation Solutions",
      desc: "Smart AI-powered technologies for modern business operations.",
      icon: LuBrain,
      colorClass: "text-[#f59e0b]",
      bgClass: "bg-[#f59e0b]/10",
      borderClass: "border-[#f59e0b]/20 hover:border-[#f59e0b]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(245,158,11,0.25)]",
    },
    {
      title: "Enterprise Technology Solutions",
      desc: "Scalable and secure systems built for enterprise growth.",
      icon: LuBuilding2,
      colorClass: "text-[#3b82f6]",
      bgClass: "bg-[#3b82f6]/10",
      borderClass: "border-[#3b82f6]/20 hover:border-[#3b82f6]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(59,130,246,0.25)]",
    },
    {
      title: "Ecommerce & Digital Platforms",
      desc: "High-performance digital solutions for seamless user experience.",
      icon: LuShoppingBag,
      colorClass: "text-[#a855f7]",
      bgClass: "bg-[#a855f7]/10",
      borderClass: "border-[#a855f7]/20 hover:border-[#a855f7]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(168,85,247,0.25)]",
    },
    {
      title: "On-Demand Technology Solutions",
      desc: "Advanced platforms for booking, delivery, and service-based businesses.",
      icon: LuClock,
      colorClass: "text-[#06b6d4]",
      bgClass: "bg-[#06b6d4]/10",
      borderClass: "border-[#06b6d4]/20 hover:border-[#06b6d4]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(6,182,212,0.25)]",
    },
    {
      title: "FinTech & Secure Systems",
      desc: "Reliable and secure fintech technologies with modern functionality.",
      icon: LuShield,
      colorClass: "text-[#6366f1]",
      bgClass: "bg-[#6366f1]/10",
      borderClass: "border-[#6366f1]/20 hover:border-[#6366f1]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(99,102,241,0.25)]",
    },
    {
      title: "Custom Technology Solutions",
      desc: "Tailored technology services designed for unique business requirements.",
      icon: LuCpu,
      colorClass: "text-[#d946ef]",
      bgClass: "bg-[#d946ef]/10",
      borderClass: "border-[#d946ef]/20 hover:border-[#d946ef]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(217,70,239,0.25)]",
    },
  ],
  processSubtitle: "Our Proven Trending Technology Development Process",
  processTitle: "Our Strategic Trending Technology Development Approach",
  processSteps: [
    {
      step: "01",
      title: "Discovery",
      description: "We analyze business goals and trending technology requirements.",
      icon: LuUsers,
    },
    {
      step: "02",
      title: "Strategy & Planning",
      description: "We define modern technologies, architecture, and development roadmap.",
      icon: LuClipboardList,
    },
    {
      step: "03",
      title: "UI/UX Design",
      description: "We create intuitive and future-ready digital experiences.",
      icon: LuLayoutDashboard,
    },
    {
      step: "04",
      title: "Technology Development",
      description: "We build scalable solutions using AI, Blockchain, Cloud, and modern technologies.",
      icon: LuCode,
    },
    {
      step: "05",
      title: "Testing & Optimization",
      description: "We ensure secure, stable, and high-performance technology solutions.",
      icon: LuBug,
    },
    {
      step: "06",
      title: "Deployment & Support",
      description: "We deploy, monitor, and provide ongoing technology support.",
      icon: LuRocket,
    },
  ],
  benefitsSubtitle: "WHY CHOOSE TRENDING TECHNOLOGIES?",
  benefitsTitle: "Why Trending Technologies are the Right Choice",
  benefits: [
    "Scalable and future-ready technology solutions",
    "Faster deployment and digital transformation",
    "Secure and high-performance infrastructure",
    "Custom integrations for modern platforms",
    "Cloud-native and flexible architecture",
    "Optimized user experience and performance",
    "Advanced automation and AI capabilities",
  ],
  logoImage: "/images/serviceBanners/AIImage.webp",
  whiteLogoImage: "/images/serviceBanners/TrandingW.webp",
};
